'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M508.118 122.046c-96.356-114.5-169.38-122.046-316.118-122.046v512c256.534-128 285.272 16.67 447.012 2.046 159.456-14.44 295.050-137.174 384.988-258.046-254.712 58.906-382.92 24.046-515.882-133.954zM0 0h128v1024h-128z' })
    ));
};